__turbopack_context__.v({
  "navbar": "NavBar-module__kk8kxq__navbar",
  "navbarLinks": "NavBar-module__kk8kxq__navbarLinks",
  "navbarMenuIcon": "NavBar-module__kk8kxq__navbarMenuIcon",
  "open": "NavBar-module__kk8kxq__open",
  "sidebar": "NavBar-module__kk8kxq__sidebar",
});
